module.exports = __webpack_public_path__ + "img/Ventuar_Metal Sword.469a1155.png";